<template>
  <div class="t-card-ganhador">
    <div v-if="$forSize['desktop-up']" class="foto-ganhador" />
    <div class="description">
      <div :style="{ backgroundImage: `url(${this.foto || require('@/assets/AVATAR.png')})` }" class="nome-ganhador">
        <slot name="nome"/>
      </div>
      <div class="data">
        <slot name="data"/>
      </div>
      <div class="texto">
        <slot name="texto"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 't-card-ganhador',
  props: {
    foto: String
  }
}
</script>

<style lang="scss" scoped>
.t-card-ganhador {
  background-color: var(--surface);
  color: var(--on-surface);
  border-radius: 10px;
  display: flex;
  margin: 7.5px;

  @include for-size(phone-only) {
    width: 100%;
  }

  @include for-size(desktop-up) {
    margin: 25px;
    width: 600px;
  }
  overflow: hidden;

  .foto-ganhador {
    background-color: var(--surface-dark);
    color: var(--surface-dark);
    min-width: 150px;
    height: 100%;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
  }

  .description {
    padding: 15px;

    .nome-ganhador {
      color: var(--secondary);
      font-size: 18px;
      letter-spacing: -1px;
      font-weight: $bold;
      @include for-size(desktop-up) {
        font-size: 22px;
      }
    }

    .data {
      margin-top: 10px;
      font-size: 14px;
      @include for-size(desktop-up) {
        font-size: 18px;
      }
    }

    .texto {
      margin-top: 20px;
      font-size: 15px;
      @include for-size(desktop-up) {
        font-size: 16px;
        margin-top: 40px;
      }
    }
  }
}
</style>
